import {
  WorkflowType,
  WorkflowTypeText,
} from 'domains/models/workflow/workflowType';
import { z } from 'zod';

export const WorkflowTypeEnum = z.nativeEnum(WorkflowType);
export const WorkflowTypeTextEnum = z.nativeEnum(WorkflowTypeText);
